<script setup lang="ts"></script>

<template>
  <div class="static-content__wrapper">
    <div class="wrapper-title">Ketentuan Layanan</div>
    <div class="wrapper-body">
      <p>
        Syarat dan Ketentuan ini merupakan perjanjian antara Pengguna
        (&ldquo;Anda&rdquo;) dan Kognisi.id by Growth Center
        (&ldquo;Kami&rdquo;), yaitu PT Digital Inisiatif yang didirikan dan
        beroperasi secara sah berdasarkan hukum Negara Republik Indonesia dan
        berdomisili di DKI Jakarta, Indonesia. Syarat dan Ketentuan ini mengatur
        Anda saat mengakses dan menggunakan situs (https://kognisi.id), fitur,
        teknologi, konten, dan produk yang Kami sediakan (selanjutnya disebut
        &ldquo;Platform&rdquo;).
      </p>

      <p>
        Harap membaca Syarat dan Ketentuan ini secara seksama sebelum mulai
        menggunakan Platform Kami, karena peraturan ini berlaku pada penggunaan
        Anda terhadap Platform Kami.
      </p>

      <p>
        Dengan mendaftar dan/atau menggunakan Platform Kami, maka Anda dan/atau
        orang tua, wali atau pengampu Anda (jika Anda berusia di bawah 18 tahun)
        dianggap telah membaca, mengerti, memahami dan menyetujui semua isi
        dalam Syarat dan Ketentuan ini.
      </p>

      <p>
        Dengan menyetujui Syarat dan Ketentuan ini, Anda juga menyetujui Syarat
        dan Ketentuan tambahan, termasuk perubahannya yang merupakan bagian yang
        tidak terpisahkan dari Syarat dan Ketentuan ini. Meskipun merupakan satu
        kesatuan, Syarat dan Ketentuan tambahan akan berlaku dalam hal terdapat
        perbedaan dengan Syarat dan Ketentuan. Jika Anda tidak menyetujui Syarat
        dan Ketentuan ini, Kami berhak untuk menghentikan akses dan penggunaan
        Anda terhadap Platform Kami.
      </p>
      <section id="pembukaan_akun_anda">
        <h4 class="wrapper-body__subtitle">A. Pembukaan Akun Anda</h4>
        <p>
          Sebelum menggunakan Platform, Anda menyetujui Syarat dan Ketentuan ini
          dan Kebijakan Privasi, dan mendaftarkan diri Anda dengan memberikan
          informasi yang Kami butuhkan. Saat melakukan pendaftaran, Kami akan
          meminta Anda untuk memberikan nama lengkap, alamat surat elektronik
          dan nomor telepon genggam pribadi Anda. Kami juga dapat menghentikan
          penggunaan Platform jika dikemudian hari data-data yang Anda berikan
          kepada Kami terbukti tidak benar.
        </p>

        <p>
          Sistem Kami akan membuatkan akun pada Platform (&ldquo;Akun&rdquo;)
          untuk Anda yang dapat digunakan untuk menggunakan Platform dan memesan
          layanan melalui Platform.
        </p>

        <p>
          Dalam hal Anda telah keluar dari Akun Anda, maka Anda perlu memasukan
          alamat surat elektronik yang ada berikan pada saat mendaftarkan diri
          Anda dan memasukan password.
        </p>

        <p>
          Akun Anda hanya dapat digunakan oleh Anda, sehingga Anda tidak dapat
          mengirimkannya kepada orang lain dengan alasan apa pun. Kami berhak
          menolak untuk memfasilitasi Layanan jika Kami mengetahui atau
          mempunyai alasan yang cukup untuk menduga bahwa Anda telah mengalihkan
          atau membiarkan Akun Anda digunakan oleh orang lain.
        </p>

        <p>
          Keamanan dan kerahasiaan Akun Anda, termasuk nama terdaftar, alamat
          surat elektronik terdaftar, nomor telepon genggam terdaftar sepenuhnya
          merupakan tanggung jawab pribadi Anda. Segala kerugian dan risiko yang
          ada akibat kelalaian Anda dalam menjaga keamanan dan kerahasiaan
          sebagaimana disebutkan ditanggung oleh Anda dan/atau orang tua, wali
          atau pengampu Anda (jika Anda berusia di bawah 18 (delapan belas)
          tahun). Dengan demikian, Kami akan menganggap setiap penggunaan atau
          pesanan yang dilakukan melalui Akun Anda sebagai permintaan yang sah
          dari Anda. Anda harap segera memberitahukan kepada Kami jika Anda
          mengetahui atau menduga bahwa Akun Anda telah digunakan tanpa
          sepengetahuan dan persetujuan Anda. Kami akan melakukan tindakan yang
          Kami anggap perlu dan dapat Kami lakukan terhadap penggunaan tanpa
          persetujuan tersebut.
        </p>
      </section>

      <section id="informasi_pribadi_anda">
        <h4 class="wrapper-body__subtitle">B. Informasi Pribadi Anda</h4>
        <p>
          Pengumpulan, penyimpanan, pengolahan, penggunaan dan pembagian
          informasi pribadi Anda, seperti nama, alamat surat elektronik, dan
          nomor telepon genggam Anda yang Anda berikan ketika Anda membuka Akun
          tunduk pada Kebijakan Privasi, yang merupakan bagian yang tidak
          terpisahkan dari Syarat dan Ketentuan ini.
        </p>
      </section>

      <section id="akses_terhadap_platform_kami">
        <h4 class="wrapper-body__subtitle">C. Akses terhadap Platform Kami</h4>
        <p>
          Kami tidak menjamin bahwa Platform Kami, maupun konten di dalamnya,
          akan selalu tersedia atau tanpa gangguan. Izin untuk mengakses
          Platform Kami bersifat sementara. Kami dapat menangguhkan, menarik,
          memberhentikan, maupun mengganti bagian mana pun dari Platform Kami
          tanpa pemberitahuan sebelumnya. Kami tidak bertanggung jawab atas
          alasan apa pun yang membuat Platform Kami tidak tersedia pada waktu
          atau periode tertentu.
        </p>
      </section>

      <section id="pembelian_dan_hak_akses_terhadap_kursus_daring_di_platform">
        <h4 class="wrapper-body__subtitle">
          D. Pembelian dan Hak Akses terhadap Kursus Daring di Platform
        </h4>

        <p>
          Terkait pembelian kelas pada Platform, Kami dapat memberi Anda lisensi
          terbatas, tidak eksklusif, dan tidak dapat dipindahtangankan untuk
          mengakses dan melihat materi dan konten terkait kelas yang telah Anda
          bayarkan. Penggunaan materi dan konten kelas secara tegas hanya untuk
          kepentingan pribadi bukan tujuan komersial. Anda tidak boleh
          memproduksi ulang, merekam, mendistribusikan kembali, mengirimkan,
          menetapkan, menjual, menyiarkan, membagi, meminjamkan, memodifikasi,
          mengadaptasi, mengedit, membuat karya turunan, sublisensi, atau
          mentransfer atau menggunakan materi dan konten pada Platform kecuali
          atas persetujuan tertulis dari Kami. Pada dasarnya Kami memberikan
          lisensi akses selama Platform ini masih beroperasi kepada Anda ketika
          Anda membeli kelas pada Platform Kami. Akan tetapi, Kami berhak
          memutuskan atau wajib menonaktifkan akses terhadap kelas karena alasan
          tertentu misalnya, jika kelas yang Anda beli merupakan salah satu
          objek suatu sengketa hak cipta. Kelas yang Anda beli juga tidak dapat
          dibatalkan atau diuangkan kembali (refund).
        </p>
      </section>

      <section id="sertifikat">
        <h4 class="wrapper-body__subtitle">E. Sertifikat</h4>

        <p>
          Anda akan mendapatkan Sertifikat Completion terhadap Kelas yang
          berhasil anda selesaikan, dengan menyelesaikan semua materi video,
          materi lain, dan materi kuis. Pemberian Sertifikat ini merupakan
          bentuk apresiasi Kami pada Anda apabila mengikuti seluruh rangkaian
          kelas dengan menyeluruh dan sebagai tanda Anda telah menguasai materi
          yang diberikan dalam kelas tersebut.
        </p>
      </section>

      <section id="ketentuan_pembayaran">
        <h4 class="wrapper-body__subtitle">F. Ketentuan Pembayaran</h4>

        <p>
          Terkait pembayaran atas kelas pada Platform Kami, Anda setuju untuk
          menggunakan alat pembayaran yang sah dengan metode yang tersedia dan
          valid, membayarkan sesuai harga pembelian akses terhadap kelas yang
          Anda beli, dan Anda memberi wewenang kepada Kami untuk melakukan
          proses transaksi jual beli atas kelas yang Anda beli dengan kartu
          kredit, kartu debit, dan alat pembayaran elektronik lainnya.
        </p>

        <p>
          Kami bekerja sama dengan Pihak Ketiga terkait proses pembayaran untuk
          memberikan layanan proses pembayaran yang nyaman dan untuk menjaga
          keamanan informasi pembayaran Anda, penjelasan lebih lanjut mengenai
          ini dapat dilihat pada Kebijakan Privasi.
        </p>

        <p>
          Jika pembayaran Anda gagal, mohon untuk segera menghubungi Kami
          melalui melalui detail kontrak yang tercantum pada poin R Syarat dan
          Ketentuan ini. Kami berhak menonaktifkan akses Anda terhadap kelas
          yang Anda beli apabila kami belum menerima pembayaran atas kelas
          tersebut. Harga yang berlaku pada suatu kela merupakan harga pada saat
          anda check out pembelian kursus. Pada suatu waktu tertentu Kami juga
          menawarkan promo dan/atau diskon untuk kelas-kelas pada Platform Kami,
          yang hanya memungkinkan Anda untuk mendapat potongan harga pada jangka
          waktu tertentu.
        </p>
      </section>

      <section id="penggunaan_yang_dilarang">
        <h4 class="wrapper-body__subtitle">G. Penggunaan yang Dilarang</h4>

        <p class="mb-0">
          Anda hanya dapat menggunakan Platform jika tidak bertentangan dengan
          atau melanggar peraturan perundang-undangan yang berlaku. Dengan
          menggunakan Platform, Anda menerima tanggungjawab penuh bahwa
          penggunaan atau akses Anda ke Platform tidak melanggar peraturan
          perundang-undangan yang berlaku. Untuk melaksanakan ketentuan ini,
          kami memiliki hak untuk menolak keanggotaan, atau menangguhkan atau
          menghentikan akun Anda segera dan tanpa pemberitahuan sebelumnya atas
          kebijakan kami sendiri.<br />
          Anda juga setuju:
        </p>

        <ol>
          <li>
            Untuk tidak mereproduksi, menggandakan, menyalin, atau menjual
            kembali bagian mana pun dari Platform Kami yang bertentangan dengan
            ketentuan dalam Syarat dan Ketentuan Platform Kami.
          </li>
          <li>
            Untuk tidak mengakses tanpa izin, mengganggu, merusak, atau
            mengacak-acak bagian mana pun dari Platform Kami, peralatan atau
            jaringan di mana Platform Kami tersimpan, perangkat lunak apa pun
            yang digunakan dalam penyediaan Platform Kami, atau peralatan atau
            jaringan atau perangkat lunak yang dimiliki oleh pihak ketiga mana
            pun.
          </li>
          <li>
            Untuk tidak dengan sengaja meneruskan data, mengirim atau mengunggah
            materi yang mengandung virus, trojan, worm, logic bomb, keystroke
            loggers, spyware, adware, maupun program berbahaya lainnya atau kode
            komputer sejenis yang dirancang untuk memberikan efek merugikan
            terhadap pengoperasian perangkat lunak atau perangkat keras apa pun.
          </li>
        </ol>
      </section>

      <section id="hak_kekayaan_intelektual">
        <h4 class="wrapper-body__subtitle">H. Hak Kekayaan Intelektual</h4>

        <p>
          Anda mengakui dan menyetujui bahwa Platform Kami, termasuk namun tidak
          terbatas pada semua isi dan konten yang terdapat pada Platform, nama,
          logo, kode program, desain, merek dagang, teknologi, basis data,
          proses dan model bisnis, dilindungi oleh hak cipta, merek, paten, hak
          moral dan hak kekayaan intelektual lainnya dimiliki oleh dan terdaftar
          secara sah pada badan pemerintahan yang berwenang atas nama Kognisi.id
          by Growth Center. Penggunaan isi dan konten Platform tunduk dan
          mengacu kepada Ketentuan Penggunaan ini. Isi, konten, gambar, suara,
          dan video pada Platform hanya boleh digunakan utuh apa adanya tanpa
          ada perubahan, untuk kebutuhan penggunaan pribadi dan non-komersial.
          Dilarang untuk melakukan pengunduhan (download) dan penggunaan lainnya
          yang melanggar Ketentuan Penggunaan ini.
        </p>
      </section>

      <section id="pengunggahan_konten_pada_platform_kami">
        <h4 class="wrapper-body__subtitle">
          I. Pengunggahan Konten Pada Platform Kami
        </h4>

        <p>
          Anda dapat menggunakan fitur yang memungkinkan Anda menggugah komentar
          mengenai kelas atau jawaban quiz ke Platform Kami. Komentar yang Anda
          gugah harus menyatakan fakta, tidak boleh mencemarkan nama baik
          seseorang atau institusi, mengandung materi kebencian; menghasut;
          menyinggung SARA, dan melanggar hukum yang berlaku di Indonesia maupun
          hukum negara mana mereka dituliskan. Anda bertanggung jawab sepenuhnya
          untuk mengamankan dan membuat cadangan dari komentar Anda maupun
          permasalahan yang mungkin timbul di kemudian hari terkait komentar
          Anda.
        </p>
      </section>

      <section id="laporan_kemungkinan_pelanggaran">
        <h4 class="wrapper-body__subtitle">
          J. Laporan Kemungkinan Pelanggaran
        </h4>

        <ol>
          <li>
            Jika Anda menemukan konten apapun pada Platform Kami yang Anda
            yakini melanggar hak cipta, melanggar hak lainnya maupun melanggar
            ketentuan hukum yang berlaku, dan melanggar Syarat dan Ketentuan ini
            dan/atau Kebijakan Privasi Kami, anda dapat melaporkannya kepada
            Kami melalui alamat email sebagaimana terlampir pada poin R.
          </li>
          <li>
            Pastikan Laporan anda memuat pernyataan bahwa Anda telah
            mengidentifikasi konten yang melanggar Syarat dan Ketentuan, atau
            Kebijakan Privasi, ataupun ketentuan hukum yang berlaku. Selain itu
            Laporan juga memuat deskripsi dari pelanggaran dan tautan di mana
            konten tersebut berada, bukti screenshot dari konten tersebut, juga
            data pribadi anda yang berupa nama lengkap; alamat; nomor telepon;
            alamat surat elektronik; serta nama pengguna akun Anda pada Platform
            Kami (jika anda memilikinya).
          </li>
          <li>
            Dengan membuat Laporan Anda dianggap telah melaporkan dengan itikad
            baik, memberikan informasi yang akurat, dan meyakini bahwa Laporan
            anda melanggar ketentuan yang berlaku sehingga Anda berwenang untuk
            bertindak atas nama pemilik hak cipta atau hak lainnya yang diduga
            telah dilanggar.
          </li>
        </ol>
      </section>

      <section id="tindakan_yang_kami_anggap_perlu">
        <h4 class="wrapper-body__subtitle">
          K. Tindakan yang Kami Anggap Perlu
        </h4>

        <p>
          Apabila Kami mengetahui, mempunyai alasan yang cukup, dan dapat
          membuktikan bahwa Anda telah melakukan tindakan yang bertentangan
          dengan Syarat dan Ketentuan; Kebijakan Privasi; maupun ketentuan hukum
          yang berlaku di Indonesia, maka Kami berhak untuk dan dapat membekukan
          Akun anda secara sementara atau permanen, bahkan menghentikan akses
          Anda terhadap Platform. Kami juga berhak melakukan pemeriksaan,
          melaporkan pelanggaran Anda pada pihak yang berwenang, menuntut ganti
          kerugian, dan/atau mengambil tindakan yang Kami anggap perlu termasuk
          tindakan hukum pidana maupun perdata.
        </p>
      </section>

      <section id="membuat_tautan_ke_platform_kami">
        <h4 class="wrapper-body__subtitle">
          L. Membuat Tautan ke Platform Kami
        </h4>

        <ol>
          <li>
            Anda dapat membuat tautan ke Platform Kami sepanjang anda
            melakukannya dengan cara yang adil, tidak melanggar ketentuan hukum
            yang berlaku, tidak merusak reputasi Kami, dan tidak mengambil
            keuntungan darinya. Namun Kami berhak mencabut izin pemberian tautan
            tanpa pemberitahuan.
          </li>
          <li>
            Anda tidak diperbolehkan membuat tautan sehingga memberi kesan
            adanya suatu asosiasi, persetujuan, ataupun dukungan dari Kami
            ketika hal tersebut tidak benar adanya.
          </li>
          <li>
            Anda tidak diperbolehkan membuat tautan ke Platform Kami pada situs
            web mana pun yang tidak dimiliki oleh Anda.
          </li>
          <li>
            Jika Anda ingin menggunakan konten pada Platform Kami selain melalui
            hal-hal yang diatur di atas, silahkan menghubungi kami sebagaimana
            diatur Poin R Syarat dan Ketentuan ini.
          </li>
        </ol>
      </section>

      <section id="tautan_pihak_ketiga_pada_platform_kami">
        <h4 class="wrapper-body__subtitle">
          M. Tautan Pihak Ketiga Pada Platform Kami
        </h4>

        <p>
          Di mana Platform Kami mengandung link and akses ke situs web dan
          konten lain yang disediakan oleh Pihak Ketiga. Kami tidak memiliki
          kontrol atas konten situs web atau sumber daya tersebut. Kami tidak
          bertanggung jawab atas bagian apapun dari isi konten yang disediakan
          oleh Pihak Ketiga. Akses atau penggunaan Anda terhadap konten Pihak
          Ketiga tersebut merupakan bentuk persetujuan Anda untuk tunduk pada
          Syarat dan Ketentuan dan kebijakan privasi yang ditetapkan oleh Pihak
          Ketiga tersebut.
        </p>
      </section>

      <section id="tanggung_jawab_anda">
        <h4 class="wrapper-body__subtitle">N. Tanggung Jawab Anda</h4>

        <p>
          Anda bertanggung jawab secara penuh atas setiap kerugian dan/atau
          klaim yang timbul dari penggunaan Platform melalui akun Anda, baik
          oleh Anda atau pihak lain yang menggunakan akun Anda, dengan cara yang
          bertentangan dengan Ketentuan Penggunaan ini, peraturan
          perundang-undangan yang berlaku, pelanggaran hak kekayaan intelektual
          dan/atau aktivitas lain yang merugikan publik dan/atau pihak lain
          manapun atau yang dapat atau dianggap dapat merusak reputasi kami.
        </p>

        <p>
          Kami tidak menjamin bahwa Platform akan aman atau terbebas dari bug
          atau virus. Anda bertanggung jawab untuk mengatur teknologi informasi,
          program komputer, serta platform yang Anda gunakan untuk mengakses
          Platform kami. Anda harus menggunakan perangkat lunak anti-virus Anda
          sendiri.
        </p>
      </section>

      <section id="batasan_tanggung_jawab_kami">
        <h4 class="wrapper-body__subtitle">O. Batasan Tanggung Jawab Kami</h4>

        <ol>
          <li>
            Platform yang Kami sediakan adalah sebagaimana adanya dan Kami tidak
            menyatakan atau menjamin bahwa keandalan, ketepatan waktu, kualitas,
            kesesuaian, ketersediaan, akurasi, kelengkapan atau keamanan dari
            Platform dapat memenuhi kebutuhan dan akan sesuai dengan harapan
            Anda.
          </li>
          <li>
            Kami tidak bertanggung jawab kepada pengguna mana pun atas kerugian
            atau kerusakan, baik dalam bentuk kontrak, perbuatan melawan hukum
            (termasuk kelalaian), pelanggaran kewajiban berdasarkan
            undang-undang, atau sebaliknya, meskipun dapat diperkirakan, yang
            terjadi di bawah atau berhubungan dengan:
            <ol>
              <li>
                Penggunaan, atau ketidakmampuan untuk menggunakan, Platform
                Kami; atau
              </li>
              <li>
                Penggunaan atau kepercayaan terhadap konten apa pun yang
                ditampilkan pada Platform Kami.
              </li>
            </ol>
          </li>
          <li>
            Kami hanya menyediakan Platform untuk penggunaan domestik dan
            pribadi. Anda setuju untuk tidak menggunakan Platform Kami untuk
            tujuan komersial atau bisnis apa pun, dan Kami tidak bertanggung
            jawab kepada Anda atas kerugian, kehilangan usaha, gangguan usaha,
            maupun hilangnya kesempatan bisnis.
          </li>
          <li>
            Kami tidak bertanggung jawab atas kerugian atau kerusakan yang
            disebabkan oleh virus, serangan Penolakan Layanan secara
            Terdistribusi (DDoS), maupun materi teknologi berbahaya lainnya yang
            dapat menginfeksi peralatan komputer, program komputer, data, atau
            materi kepemilikan lainnya karena penggunaan maupun pengunduhan
            konten apa pun dari Platform Kami maupun situs web lain yang terkait
            dengannya oleh Anda.
          </li>
          <li>
            Kami tidak berkewajiban untuk mengawasi akses atau penggunaan Anda
            terhadap Platform. Akan tetapi, Kami akan tetap melakukan pengawasan
            untuk memastikan kelancaran penggunaan Platform dan untuk memastikan
            kepatuhan Anda terhadap Syarat dan Ketentuan ini, peraturan
            perundang-undangan yang berlaku, putusan pengadilan, dan/atau
            ketentuan lembaga administratif atau badan pemerintahan lainnya.
          </li>
          <li>
            Kami tidak bertanggung jawab atas konten situs web yang terhubung
            dengan Platform Kami. Tautan semacam itu seharusnya tidak
            ditafsirkan sebagai bentuk dukungan Kami terhadap situs-situs
            tersebut. Kami tidak bertanggung jawab atas kerugian atau kerusakan
            apa pun yang timbul dari penggunaan Anda terhadap situs-situs web
            tersebut.
          </li>
        </ol>
      </section>

      <section id="keadaan_kahar">
        <h4 class="wrapper-body__subtitle">P. Keadaan Kahar (Force Majeure)</h4>

        <p>
          Platform Kami dapat diinterupsi oleh kejadian di luar kewenangan atau
          kontrol kami, termasuk namun tidak terbatas pada bencana alam,
          gangguan listrik, gangguan telekomunikasi, kebijakan pemerintah, dan
          lain-lain (&ldquo;Keadaan Kahar&rdquo;). Anda setuju untuk membebaskan
          Kami dari setiap klaim dan tuntutan, jika kami tidak dapat
          memfasilitasi akses dan/atau penggunaan Platform, baik sebagian maupun
          seluruhnya, karena suatu Keadaan Kahar.
        </p>
      </section>

      <section id="hukum_yang_berlaku">
        <h4 class="wrapper-body__subtitle">Q. Hukum yang Berlaku</h4>

        <p>
          Syarat dan Ketentuan ini diatur berdasarkan hukum Republik Indonesia.
          Setiap dan seluruh perselisihan yang timbul dari penggunaan Platform
          tunduk pada yurisdiksi Pengadilan Negeri Jakarta Pusat.
        </p>
      </section>

      <section id="ketentuan_lainnya">
        <h4 class="wrapper-body__subtitle">R. Ketentuan Lainnya</h4>

        <ol>
          <li>
            Anda mengerti dan setuju bahwa Syarat dan Ketentuan ini merupakan
            perjanjian dalam bentuk elektronik dan tindakan Anda menekan tombol
            &lsquo;daftar&rsquo; saat pembukaan Akun atau tombol
            &lsquo;masuk&rsquo; saat akan mengakses Akun Anda merupakan
            persetujuan aktif Anda untuk mengikatkan diri dalam perjanjian
            dengan Kami sehingga keberlakuan Syarat dan Ketentuan ini dan
            Kebijakan Privasi adalah sah dan mengikat secara hukum dan terus
            berlaku sepanjang penggunaan Platform oleh Anda.
          </li>
          <li>
            Kami dapat mengubah Syarat dan Ketentuan ini dari waktu ke waktu,
            perubahan mana akan diberitahukan kepada Anda dalam bentuk dan
            melalui sarana apapun, termasuk namun tidak terbatas pada
            pemberitahuan melalui e-mail; dan Anda setuju bahwa Anda bertanggung
            jawab untuk meninjau Syarat dan Ketentuan ini secara berkala. Anda
            dapat menyampaikan keberatan atas perubahan dan/atau penambahan atas
            Syarat dan Ketentuan yang berlaku yang dianggap merugikan Anda
            secara komersial dan material dalam jangka waktu 14 (empat belas)
            hari kalender sejak perubahan dan/atau penambahan tersebut
            dipublikasikan. Kami berhak untuk menghentikan akses Anda terhadap
            Platform dalam hal Anda berkeberatan atas perubahan dan/atau
            penambahan Syarat dan Ketentuan yang berlaku tersebut.
          </li>
          <li>
            Kami dapat mengembangkan Platform dari waktu ke waktu serta mengubah
            kontennya kapan pun. Meskipun demikian, perlu diketahui bahwa
            Platform Kami dapat memiliki konten yang tidak diperbarui pada waktu
            tertentu, dan Kami tidak bertanggung jawab untuk memperbaikinya.
            Kami tidak menjamin bahwa Platform Kami, maupun konten yang
            terkandung di dalamnya, dapat bebas sepenuhnya dari kesalahan atau
            kelalaian.
          </li>
          <li>
            Anda tidak akan mengajukan tuntutan atau keberatan apapun terhadap
            keabsahan dari Syarat dan Ketentuan atau Kebijakan Privasi yang
            dibuat dalam bentuk elektronik.
          </li>
          <li>
            Anda tidak dapat mengalihkan hak Anda berdasarkan Syarat dan
            Ketentuan ini tanpa persetujuan tertulis sebelumnya dari Kami.
            Namun, Kami dapat mengalihkan hak Kami berdasarkan Syarat dan
            Ketentuan ini setiap saat kepada pihak lain tanpa perlu mendapatkan
            persetujuan terlebih dahulu dari atau memberikan pemberitahuan
            sebelumnya kepada Anda.
          </li>
          <li>
            Bila Anda tidak mematuhi atau melanggar ketentuan dalam Syarat dan
            Ketentuan ini, dan Kami tidak mengambil tindakan secara langsung,
            bukan berarti Kami mengesampingkan hak Kami untuk mengambil tindakan
            yang diperlukan di kemudian hari.
          </li>
          <li>
            Ketentuan ini tetap berlaku bahkan setelah pembekuan sementara,
            pembekuan permanen, penghapusan Platform atau setelah berakhirnya
            perjanjian ini antara Anda dan Kami.
          </li>
        </ol>
      </section>

      <div class="ketentuan-layanan__info">
        <div class="info-title">Hubungi Kami</div>
        <div class="info-body">
          <p>
            Saya dan/atau orang tua, wali atau pengampu saya telah membaca dan
            mengerti seluruh Syarat dan Ketentuan ini dan konsekuensinya dan
            dengan ini menerima setiap hak, kewajiban, dan ketentuan yang diatur
            di dalamnya.
          </p>

          <p class="mb-0">
            Jika Anda memiliki pertanyaan mengenai ketentuan layanan ini atau
            Anda ingin mendapatkan akses dan/atau melakukan koreksi terhadap
            Informasi Pribadi Anda, Anda dapat menghubungi Kami melalui
          </p>
          <a href="mailto:kognisi@growthcenter.id">kognisi@growthcenter.id</a>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use './styles.scss';
</style>
